import React from 'react';

import {ReportConfirmOptions} from '../../../store/reportStore/reportDialogStore';

interface ReportConfirmModalProps {
  options: ReportConfirmOptions;
  onClose: () => void;
}

const ReportConfirmModal: React.FC<ReportConfirmModalProps> = ({
  options,
  onClose
}) => {
  const {
    title = 'Confirm',
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'default',
    onConfirm,
    onCancel
  } = options;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  const confirmClass =
    variant === 'danger'
      ? 'report-dialog-btn report-dialog-btn--danger'
      : 'report-dialog-btn report-dialog-btn--primary';

  return (
    <div className="reportComponents">
      <div
        className="report-dialog-overlay"
        onMouseDown={handleCancel}
        role="presentation"
      >
        <div
          className="report-dialog-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="report-dialog-title"
          onMouseDown={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="report-dialog-header">
            <h3 id="report-dialog-title">{title}</h3>
          </div>
          <div className="report-dialog-body">
            <p>{message}</p>
          </div>
          <div className="report-dialog-footer">
            <button
              type="button"
              className="report-dialog-btn report-dialog-btn--cancel"
              onClick={handleCancel}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className={confirmClass}
              onClick={handleConfirm}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportConfirmModal;
